import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {Box} from '@mui/material';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <Box sx={{width: 1}}>
        <App/>
    </Box>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
